import React from 'react'
import './Howitwork.css'
function Howitwork() {
  return (
    <div className='outerclass'>
      <h2>How it Work</h2>
      <p>Finding the one made simple: effortless, versatile, and enjoyable</p>
<ol>
    <li >
        <div class="icon"><i class="fa-solid fa-house" style={{color: '#b8df4e'}}></i></div>
        <div class="title">Step 1</div>
        <div class="descr"><h5>choose your property</h5></div>
    </li>
    <li >
        <div class="icon"><i class="fa-solid fa-phone" style={{color: '#4cbccb'}}></i></div>
        <div class="title">Step 2</div>
        <div class="descr"><h5>Connect with Us</h5></div>
    </li>
    <li >
        <div class="icon"><i class="fa-solid fa-handshake" style={{color: '#7197d3'}}></i></div>
        <div class="title">Step 3</div>
        <div class="descr"><h5>Close the deal</h5>.</div>
    </li>
    
</ol>

    </div>
  )
}

export default Howitwork
